import {render, cookieExistiert} from "../../assets/js/utils.js";

class FreiexemplarBuchhaendlerBootstrap extends HTMLElement {
    constructor() {
        super();
        this.initListener();
    }

    disconnectedCallback() {
        this.disconnect();
    }

    get uri() {
        return this.dataset["uri"];
    }

    initListener() {
        this.observer = this.initObserver();
        this.addAnchorScrollListener();
    }

    disconnect() {
        this.observer.disconnect();
    }

    destroy() {
        this.remove();
    }

    addAnchorScrollListener() {
        document.addEventListener("sbe.anchorScroll.start", () => {
            this.disconnect();
        }, { once: true });
        document.addEventListener("sbe.anchorScroll.finish", () => {
            this.initListener();
        }, { once: true });
    }

    initObserver() {
        const observer = new IntersectionObserver((entries) => {
            for (const entry of entries) {
                this.observeFreiexemplarBuchhaendler(entry);
            }
        });
        observer.observe(this);
        return observer;
    }

    observeFreiexemplarBuchhaendler(entry) {
        if (entry.isIntersecting && cookieExistiert("LES_BUCHHAENDLER")) {
            this.initializeFreiexemplarBuchhaendler();
        }
    }

    async initializeFreiexemplarBuchhaendler() {
        try {
            const response = await fetch(this.uri);
            const html = await response.text();
            render(this, html, true);
        } catch (error) {
            this.destroy();
        } finally {
            this.disconnect();
        }
    }
}

if (!customElements.get("freiexemplar-buchhaendler-bootstrap")) {
  customElements.define("freiexemplar-buchhaendler-bootstrap", FreiexemplarBuchhaendlerBootstrap);
}
